import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	moreVersions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	moreVersions: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.more-button.more-versions',
		defaultMessage: 'More actions for {issueKey}',
		description:
			'Button label of a meatball menu, indicating user is will get more options if it is clicked',
	},
});
export default messages;
